export const userPingToColor = (ping: number) => {
  if (ping < 100) {
    return "bg-green-500";
  } else if (ping < 200) {
    return "bg-yellow-500";
  } else {
    return "bg-red-500";
  }
};
